var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.noButton ? 'div' : 'button',_vm._g({tag:"component",staticClass:"icon-button",class:{
        'icon-button--disabled': _vm.disabled,
        'icon-button--filled': _vm.type === 'filled',
        'icon-button--labeled': _vm.label,
        'icon-button--outlined': _vm.type === 'outlined',
    }},_vm.$listeners),[_c('div',{staticClass:"icon-button__content"},[_c('div',{staticClass:"icon-button__hover",style:(_vm.hoverElementStyle)}),_vm._t("default")],2),(_vm.label)?_c('div',{staticClass:"icon-button__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }